import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MonthlyAttendancePreview.css'; // Reuse the same CSS for consistency
import { submitAttendance } from '../../../services/monthlyAttendanceService';
import { getAuditLog, getDaysInMonth } from '../../../utils/calculateDaysInMonthUtils';

const MonthlyAttendancePreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { year, month, districtId, projectId, attendanceData: initialData } = location.state || {};
  const savedAttendance = JSON.parse(localStorage.getItem('attendanceFormState') || '{}').attendanceData || [];
  const [attendanceData, setAttendanceData] = useState(savedAttendance.length ? savedAttendance : initialData || []);

  const goBack = () => {
    navigate('/monthlyAttendance', {
      state: { year, month, districtId, projectId, attendanceData },
    });
  };

  const handleSubmit = async () => {
    if (!attendanceData || attendanceData.length === 0) {
      alert('No data to submit.');
      return;
    }

    try {
      // ✅ Filter only RESUBMIT rows if present
      const hasResubmit = attendanceData.some(row => row.status === "RESUBMIT");
      const dataToSubmit = hasResubmit
        ? attendanceData.filter(row => row.status === "RESUBMIT")
        : attendanceData;

      const payload = dataToSubmit.map(row => {
        const base = {
          employeeId: row.employeeId,
          employeeUniqueId: row.employeeUniqueId,
          fullName: row.fullName,
          designation: row.designation,
          presentDays: Number(row.presentDays) || 0,
          casualLeaveDays: Number(row.casualLeave) || 0,
          absentDays: row.daysAbsent || 0,
          payableDays: ((Number(row.presentDays) || 0) + (Number(row.casualLeave) || 0)
          ),
          totalDaysInMonth: row.totalDaysInMonth || getDaysInMonth(month, year),
          location: Array.isArray(row.godownNames)
            ? row.godownNames.join(", ")
            : (row.godownNames || 'N/A'),
          month: row.month || month,
          year: row.year || year,
          districtId: row.districtId || districtId,
          projectId: row.projectId || projectId,
          auditLog: getAuditLog(),

        };

        // ✅ Only add id if attendanceId exists
        if (row.attendanceId) {
          base.id = row.attendanceId;
        }

        return base;
      });

      console.log("Submitting payload:", payload);

      await submitAttendance(payload, hasResubmit);

      alert(
        hasResubmit
          ? "Attendance resubmitted successfully!"
          : "Attendance submitted successfully!"
      );


      setAttendanceData([]);
      localStorage.removeItem('attendanceData');
      localStorage.removeItem('attendanceFormState');
      navigate('/monthlyAttendance');

    } catch (error) {
      console.error('Error submitting attendance:', error.response?.data || error.message);
      alert(error.response?.data?.error || 'Failed to submit attendance. Please try again.');
    }
  };


  //Function to calculate days in a month (for fallback)
  // const getDaysInMonth = (monthId, year) => {
  //   const monthIndex = monthId - 1;
  //   if (!monthId || !year) return 0;
  //   const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
  //   const monthsWith30Days = [4, 6, 9, 11];
  //   if (monthsWith31Days.includes(monthId)) {
  //     return 31;
  //   } else if (monthsWith30Days.includes(monthId)) {
  //     return 30;
  //   } else if (monthId === 2) {
  //     const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //     return isLeapYear ? 29 : 28;
  //   }
  //   return 0;
  // };
//{month}/{year}
  return (
    <div className="monthly-attendance-container">
      <div className="monthly-attendance-box">
        <h2 className="monthly-attendance-heading">  Attendance Preview For {new Date(0, month - 1).toLocaleString('default', { month: 'long' })}, {year} </h2>
        <div className="attendance-table-container">
          <table className="attendance-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Employee Id</th>
                <th>Employee Name</th>
                <th>Designation</th>
                <th>DHQ/ Godown Name</th>
                <th>No of Days in Month</th>
                <th>No of Days Present</th>
                <th>Casual Leave (CL)</th>
                <th>No of Days Absent</th>
                <th>Total No of Days Present</th>
                <th>CL Used Status</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: 'center', padding: '10px' }}>
                    No data available
                  </td>
                </tr>
              ) : (
                attendanceData.map((row, index) => {
                  const daysInMonth = row.totalDaysInMonth || getDaysInMonth(month, year);
                  const daysAbsent = row.daysAbsent || 0;
                  const payableDays = daysAbsent === 0 ? daysInMonth : (Number(row.presentDays) || 0) + (Number(row.casualLeave) || 0);

                  return (
                    <tr key={row.id || index}>
                      <td>{index + 1}</td>
                      <td>{row.employeeId || 'N/A'}</td>
                      <td>{row.fullName || 'N/A'}</td>
                      <td>{row.designation || 'N/A'}</td>
                      <td>{row.godownNames || row.godownNames || 'N/A'}</td>
                      <td>{daysInMonth}</td>
                      <td>{row.presentDays || 0}</td>
                      <td>{row.casualLeave || 0}</td>
                      <td>{row.daysAbsent || 0}</td>
                      <td>{payableDays >= 0 ? payableDays : 0}</td>
                      <td>{row.usedLeaves || 0}/{row.leaves || 0}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
          <div className="monthly-submit-btn-div-back">
            <button onClick={goBack} className="monthly-clear-btn-back">Back</button>
            <button
              onClick={handleSubmit}
              className="monthly-attendance-btn-back"
              style={{ backgroundColor: 'green', color: 'white' }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyAttendancePreview;